module.exports = __webpack_public_path__ + "static/banner-dog-d95fc1d9765641f69e19aa2fbbaa66ae.jpg";